import crypto from 'crypto';

import { encryptRSA, decryptRSA, signFn, verifyFn } from './rsa';
import { aesEncrypt, aesDecrypt } from './aes';

// 服务端公钥
const PUB_KEY = '-----BEGIN PUBLIC KEY-----\n' +
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAv/OdjyzSP9CdnSyRle8y\n' +
    'iyG9aOAWx6VGIeWJbAx/yfJN+15WtPDhtekcQeCXKSFpQ6MUUSpkJSplg0XvYt8n\n' +
    'MnDWZzo7MLPCH4aHU4dUj8GKT3LCNWm5CoidIZmexDPzUD1+HF5XfN53wXc/JZcR\n' +
    'zBBIpfcM/aQzET0Hx+e4shGE4sgng6uaG5EuxD7TvAJLMmLsNUJMLb1oow0GHUxP\n' +
    '8CqulPlDarG9rVSfSDR4TmXqlIebnlxfdjIQ/7FjEdkquZEqODUWNA3G6v/Z9dJf\n' +
    '/4dmadJsQPCTgzZ9/b7Chbe2pOlNpXLLI++fvVIncVrtf6aM0gcrzzdLOWdNqgpz\n' +
    'jQIDAQAB\n' +
    '-----END PUBLIC KEY-----';


// 前端的私钥
const PRIV_KEY_FE = '-----BEGIN PRIVATE KEY-----\n' +
    'MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDLzeNcT8Tr5HPv\n' +
    'pXpWH+St878ZnH4p4RT5xC8/EfB7L8QQGHEojuMBo8LLfRtyRjv0fHDs7z5R5xkj\n' +
    '0TRCk6ps1YxGoCq1IlaWJ60czH6Ypk6BFO2lE+1VLN95iEOoy0ZYYoqAFw+RJWNF\n' +
    'QUCvBhvVaN/wwpbswvOzPdOItFqPlO1VRUCR0T5CibPFoiie2CxaLj9N0LfGgWvA\n' +
    'FFEYZKMpZireRaX1T1G/IaTe5z/gYLGYXel+YBMRpET3eDloAoQxu0m9L7ZOg2FE\n' +
    'GqIsjfUP4QWyZ9VGvYjpboaF2k1hLwgb+9TP8flxaePcV6zoEU7ejDDp7u6+W5fO\n' +
    'BvGPD64nAgMBAAECggEBAJPvMBDqqiMcYfdbI3Dul5yY6GcbzAx0IDioai8aw3d3\n' +
    'lZalV0Y8aZTgHN5+QnTxfEWcKpAhnRfwarQwAAIvk66KV9dQHY/7i+RUinj0CxSc\n' +
    '6zERUurXixefidt6yLn2S2qOpMATfS47eFJl6iDhi0SeaqclaE4VuLWrtCdv2qiL\n' +
    'AplohEZrrcagJzpqAIKzi2VXgQWENUqoEPUowIs1AdHeCSbf0AfHq6ytgCLyyYcV\n' +
    'f2A4Q6zPLk5WhgErd+t3o7CSEUAzYlcpbzmnZqO8Vzqqi2UG2rGxTgv4/ckWa96d\n' +
    'gsuMrROyjJn6rbvUn8n9zLrdFbavt+4Szjse2vzBkWECgYEA8Xsk1/DtdpWZ9gGU\n' +
    'vDX5s2sMBfINlqB30/m8r+Hfi56fxTncrDVrE0MfPMbscKOHanJFfPV/Wx8mSyEq\n' +
    'BLHqLkjE7tByPeutO/TOPmtfsRcLrkTizHpcuqXYWOTCpF50YrjCIbB09fUm4U9y\n' +
    'bJFTE8la7yw4778fEnp9kadtHVcCgYEA2A7TiWQV0iKpOUsixwNTl+OCpYUKvF8L\n' +
    '4c5O8hn5TGTPTZ642kf6kbY0B5+toyM3g9pVCnwQvebU2hU9H/B4RP1alzTDAp2t\n' +
    'ozwYFgIj26cnvdw5oDqVntdjLKIegW94NyjRdUGOBzC7XJ87xqfwuIq37InBmxuo\n' +
    'O97FF36Qo7ECgYEAgAm4Tlsrva2y9bJ+55CC9nPy6xAdzlkFUDrhpixQeFpCArQc\n' +
    'Yp7sSElVvccHxO2gNnuihpAw1+LbTgimm9it/56L9MhHWrekod66oHQUR/SdN+jE\n' +
    'jIDwu/KFlRSuc7K1aUbngC9sxKEY3Wxfkls3vo0MDzbWdaBT3FtgSyOIAn8CgYBf\n' +
    'tEGTrFfWGzBmhpfDHAAdWdP3SbV1t4xl26Mwrry1UDpboaE0X4nonZLyhZK+nszq\n' +
    'hP4ChO5NkEBc0eefjD9aH/fO3ro7IGlX0zjAFvaXR7Xc7f5AsXKxR6tQjAeDQkM3\n' +
    '+8a8b+tf2ABGiOpLlvyUYi4SgvrVoCynSIh5XcDoIQKBgDKnbGIoqMuVihwXqIbe\n' +
    'pYdnhjeKMBrpGywQZjsjnQeZQgeQ6avG19hTpcrZTxwmFazO3Wj7Pu734qUqy2NZ\n' +
    'P2dzxP99bslOlnv47p3xCbytxiBDiO2d1VmDzHxuMIY6aVzb0YNWjU4LgSID/qN+\n' +
    'r50snyqKFbVCe5LogxvozNtO\n' +
    '-----END PRIVATE KEY-----';

/*AES加密*/
export function encrypt(params) {
    // 生成对称加密的秘钥 128位
    const aesKey = crypto.randomBytes(Math.ceil(8)).toString('hex').slice(0, 16);
    const dataStr = JSON.stringify(params);
    console.log('原文：' + dataStr);
    console.log('aesKey:' + aesKey);

    const encryptParams = aesEncrypt(dataStr, aesKey);
    console.log('加密后：' + encryptParams);

    // 用服务端给的公钥 对秘钥用RSA算法进行非对称加密
    const key = encryptRSA(aesKey, PUB_KEY);
    console.log('RSA加密后aesKey后得到的key:' + key);

    // 对key和加密后的参数进行排序
    const raw = [key, encryptParams].sort().join('');
    console.log('raw:' + raw);

    // 生成签名
    const sign = signFn(raw, PRIV_KEY_FE);
    console.log('sign算法得到的字符串：' + sign);

    // 把加密后的参数、加密后的秘钥、签名返回
    return {params: encryptParams, key, sign};
}

export function decrypt(body) {
    console.log(body, 'body', typeof body);
    const {key, sign, content} = body || {};

    // 对key和返回的数据content进行排序
    const signContent = [key, content].sort().join('');

    const isVerifySuccess = verifyFn(signContent, sign, PUB_KEY);
    console.log('验证签名的结果是：' + isVerifySuccess);
    if (!isVerifySuccess) {
        return JSON.stringify({code: 2, msg: '验证签名算法失败', data: {}});
    }

    // 用前端私钥对秘钥进行解密
    const aesKey = decryptRSA(key, PRIV_KEY_FE);
    console.log(aesKey, '解密后得到的秘钥');
    const encryptBody = content.replace(/\n/gm, '');
    // 用解密后的秘钥对数据进行解密
    const data = aesDecrypt(encryptBody, aesKey);
    console.log(data, 'data 解密后 在customCrypto');
    return data;
}
